var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllergies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 28C7.54688 28 7 28.5859 7 29.25C7 29.9531 7.54688 30.5 8.25 30.5C8.91406 30.5 9.5 29.9531 9.5 29.25C9.5 28.5859 8.91406 28 8.25 28ZM8.25 20.5C7.54688 20.5 7 21.0859 7 21.75C7 22.4531 7.54688 23 8.25 23C8.91406 23 9.5 22.4531 9.5 21.75C9.5 21.0859 8.91406 20.5 8.25 20.5ZM8.25 24.25C7.54688 24.25 7 24.8359 7 25.5C7 26.2031 7.54688 26.75 8.25 26.75C8.91406 26.75 9.5 26.2031 9.5 25.5C9.5 24.8359 8.91406 24.25 8.25 24.25ZM12 22.375C11.2969 22.375 10.75 22.9609 10.75 23.625C10.75 24.3281 11.2969 24.875 12 24.875C12.6641 24.875 13.25 24.3281 13.25 23.625C13.25 22.9609 12.6641 22.375 12 22.375ZM31.0625 12.0234L25.6719 10.5781C25.0078 10.3828 24.3047 10.7734 24.1484 11.4375L23.5234 13.7031L30.125 20.2656L31.9219 13.5469C32.1172 12.8828 31.7266 12.1797 31.0625 12.0234ZM22.9766 14.875C22.625 14.5625 22.0391 14.7188 21.9219 15.1875L20.5156 20.5H15.75C15.0469 20.5 14.5 21.0859 14.5 21.75V29.25C14.5 29.9531 15.0469 30.5 15.75 30.5H27.2734C27.8203 30.5 28.3281 30.1484 28.4844 29.6016L30.2031 23C30.3203 22.5703 30.2031 22.1016 29.8906 21.7891L22.9766 14.875ZM12 26.125C11.2969 26.125 10.75 26.7109 10.75 27.375C10.75 28.0781 11.2969 28.625 12 28.625C12.6641 28.625 13.25 28.0781 13.25 27.375C13.25 26.7109 12.6641 26.125 12 26.125Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergies);
export default __webpack_public_path__ + "static/media/allergies.696fa193.svg";
export { ForwardRef as ReactComponent };